import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function HomeRedirect() {
    const { user, isAuthenticated } = useAuth();
    
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    
    // Redirect based on role
    if (user?.role === 'poster') {
        return <Navigate to="/poster/dashboard" replace />;
    }
    
    // Default for artists/submitters/admins
    return <Navigate to="/opportunities" replace />;
}
